<template>
    <div class="ampu-ranking card">
        <div class="title m-b-20">성과 지표</div>
        <div class="table">
            <div class="table-head f-medium">
                <div class="tr">닉네임</div>
                <div class="tr cursor-pointer" @click="sortByAmpu">
                    AMPU
                    <i class="material-icons">arrow_drop_down</i>
                </div>
                <div class="tr cursor-pointer" @click="sortByAmpuNewFemale">
                    AMPU(신규여성)
                    <i class="material-icons">arrow_drop_down</i>
                </div>
            </div>
            <div class="contents">
                <div class="table-content" v-for="agent in agentsAll" :key="agent.agent_id">
                    <div class="td nickname f-regular">
                        <div class="me-badge m-r-4" v-if="$store.getters.agent.id === agent.agent_id">나</div>
                        <span>{{ agent.nickname }}</span>
                    </div>
                    <div class="td ampu f-regular c-black" v-html="agent.ampu.toFixed(2)" />
                    <div class="td ampu-newbie f-regular c-black" v-html="agent.ampu_new_female.toFixed(2)" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import agentService from '@/services/agent'
export default {
    name: 'AmpuRanking',
    data: () => ({
        agentsAll: [],
        sort: 'ampu',
    }),
    created() {
        agentService.getAllAgentsInfo().then(res => {
            // this.agentsAll = res.all.filter(r => r.ampu_new_female)
            this.agentsAll = res.all
            this.agentsAll.sort((a, b) => b.ampu - a.ampu)
        })
    },
    methods: {
        sortByAmpu() {
            if (this.sort === 'ampu') return

            this.agentsAll = this.agentsAll.sort((a, b) => b.ampu - a.ampu)
            this.sort = 'ampu'
        },
        sortByAmpuNewFemale() {
            if (this.sort === 'ampu_new_female') return

            this.agentsAll = this.agentsAll.sort((a, b) => b.ampu_new_female - a.ampu_new_female)
            this.sort = 'ampu_new_female'
        },
    },
}
</script>

<style scoped lang="scss">
.ampu-ranking {
    height: calc(100vh - 40px);
    min-width: 480px;

    .title {
        color: black;
        font-size: 16px;
        margin: 16px;
        @include f-medium;
    }
    .table {
        width: 100%;
        height: 100%;
        overflow: hidden;

        .contents {
            height: calc(100% - 60px);
            overflow-y: scroll;
        }

        .table-content {
            display: grid;
            grid-template-columns: repeat(3, 1fr);
            padding: 12px 0;
            color: $grey-07;

            &:hover {
                background-color: $grey-01;
            }
        }
        .table-head {
            @extend .table-content;
            border-bottom: 1px solid $grey-02;
            font-size: 12px;
            color: $grey-05;
        }
        .tr,
        .td {
            @include center;

            &.nickname {
                color: $grey-07;

                .me-badge {
                    background-color: $purple-primary;
                    border-radius: 4px;
                    color: white;
                    padding: 0 2px;
                    font-size: 10px;
                    @include center;
                }
            }
        }
    }
}
</style>
